import { IIndicatorData } from "./iindicator-data-strategy";
import { IndicatorData } from "./indicator-data";

export class BeneficiaryUsageIndicatorData implements IIndicatorData {
  private readonly name: string = "BeneficiaryUsage";

  constructor(private readonly items: IndicatorData[]) {}

  getName(): string {
    return this.name;
  }

  getTotal(): string {
    return this.items[0].getValue() as string;
  }

  getUsagePercentage(): string {
    return this.items[1].getValue() as string;
  }
}
